module.exports = __webpack_public_path__ + "img/targetmedia_latam_logo.652c6d55.jpeg";